const redirectToExternalPage = (url, newWindow = false) => {
  if (typeof window !== 'undefined') {
    if (newWindow) {
      window.open(url, '_blank');
    } else {
      window.open(url, '_self');
    }
  }
};

export default redirectToExternalPage;
